export interface IGeneralSettingsState {
  hiddenRaceCountries: any[];
  showTopWinnings: boolean;
  chat: {
    enabled: boolean;
  };
}

export const initialGeneralSettingsState: IGeneralSettingsState = {
  hiddenRaceCountries: [],
  showTopWinnings: false,
  chat: {
    enabled: false,
  },
};
